<script lang="ts">
	import { onMount } from "svelte";
	import { page } from '$app/stores';
    import { _ } from 'svelte-i18n';
  
    const lang = $page.params.locale;
    const currentPath = $page.url.pathname.replace(`/${$page.params.locale}`, '');

	// svelte-ignore export_let_unused
	export let info;

    let isScrolled = false; // Menentukan apakah header sudah di-scroll
	let isScrollingUp = false; // Menentukan apakah user sedang scroll ke atas
	let lastScrollY = 0;

	onMount(() => {
		const handleScroll = () => {
		const currentScrollY = window.scrollY;

		isScrolled = currentScrollY > 50; // Header bersembunyi jika scroll lebih dari 50px
		isScrollingUp = currentScrollY < lastScrollY; // Menentukan arah scroll
		lastScrollY = currentScrollY;
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
		window.removeEventListener("scroll", handleScroll);
		};
	});
</script>


<header class="w-full bg-white overflow-hidden transition-all duration-300 hidden sm:block">
	<div id="top" 
		class="border-b border-[#dad9d6] transition-all duration-300 "
		class:translate-y-[-100%]={!isScrollingUp && isScrolled}
		class:translate-y-0={isScrollingUp || !isScrolled}
		> 
		<div class="flex items-center container py-[10px]">
			<div class="w-[40%]">
				<ul class="font-secondary text-[1rem] 2xl:text-[1rem] xl:text-[1rem] lg:text-[.8rem] flex gap-[10px]">
					<li>
						<a href="tel:{info[0].phone.number}" class="flex items-center gap-2 text-primary">
							<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M220.78,162.13,173.56,141A12,12,0,0,0,162.18,142a3.37,3.37,0,0,0-.38.28L137,163.42a3.93,3.93,0,0,1-3.7.21c-16.24-7.84-33.05-24.52-40.89-40.57a3.9,3.9,0,0,1,.18-3.69l21.2-25.21c.1-.12.19-.25.28-.38a12,12,0,0,0,1-11.36L93.9,35.28a12,12,0,0,0-12.48-7.19A52.25,52.25,0,0,0,36,80c0,77.2,62.8,140,140,140a52.25,52.25,0,0,0,51.91-45.42A12,12,0,0,0,220.78,162.13ZM220,173.58A44.23,44.23,0,0,1,176,212C103.22,212,44,152.78,44,80A44.23,44.23,0,0,1,82.42,36a3.87,3.87,0,0,1,.48,0,4,4,0,0,1,3.67,2.49l21.11,47.14a4,4,0,0,1-.23,3.6l-21.19,25.2c-.1.13-.2.25-.29.39a12,12,0,0,0-.78,11.75c8.69,17.79,26.61,35.58,44.6,44.27a12,12,0,0,0,11.79-.87l.37-.28,24.83-21.12a3.93,3.93,0,0,1,3.57-.27l47.21,21.16A4,4,0,0,1,220,173.58Z"></path></svg>
							<p class="whitespace-nowrap">{ info[0].phone.display }</p>
						</a>
					</li>
					<li>
						<span class="h-full w-[1px] bg-primary block"></span>
					</li>
					<li>
						<a href="mailto:{info[0].email}" class="flex items-center gap-2 text-primary">
							<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52Zm-10.28,8L128,138.57,42.28,60ZM216,196H40a4,4,0,0,1-4-4V65.09L125.3,147a4,4,0,0,0,5.4,0L220,65.09V192A4,4,0,0,1,216,196Z"></path></svg>
							<p>{ info[0].email }</p>
						</a>
					</li>
				</ul>
			</div>
			<div class="w-[20%] flex justify-center items-center">
				<a href="/{$page.params.locale}">
					<img src="/images/jcc-logo.png" class="h-[8vh] object-contain" height="200" width="200" alt="images">
				</a>
			</div>
			<div class="w-[40%] flex justify-end items-center">
				<a id="btn-booknow-1" data-sveltekit-reload href="/{$page.params.locale}/contact" class="font-primary text-primary border border-primary py-[10px] px-[20px] text-[1rem] 2xl:text-[1rem] xl:text-[1rem] lg:text-[.8rem] uppercase hover:bg-[#ceb4a9] transition-all duration-300">
					{$_('nav-bookavailability')}
				</a>
			</div>
		</div>
	</div>
</header>

<div id="bottom" class="hidden sm:flex sticky top-0 bg-white !transition-all !duration-300 z-30 shadow-[0_3px_10px_rgb(0,0,0,0.2)]"
class:justify-between={isScrolled}
class:justify-center={!isScrolled}
>
	<div class="w-[70%] transition-all duration-300"
		 class:ml-[50px]={isScrolled}
         class:ml-0={!isScrolled}
		 class:w-[50%]={isScrolled}
         class:w-[70%]={!isScrolled}
	>
		<ul class="flex uppercase justify-between font-primary text-primary 2xl:text-[1rem] xl:text-[1rem] lg:text-[.8rem]">
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-home')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/about" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-about')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/venues" class="relative whitespace-nowrap inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-venues')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/services" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-services')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/events" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-events')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/offers" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-offers')}</a>
			</li>
			<li>
				<a data-sveltekit-reload href="/{$page.params.locale}/contact" class="relative inline-block py-[15px] px-[15px] after:transition-all after:duration-300 after:content-[''] after:block after:bg-transparent after:w-full after:h-[3px] after:absolute after:bottom-0 after:left-0 hover:after:bg-primary"
				class:py-[25px]={isScrolled}
         		class:py-[15px]={!isScrolled}
				>{$_('nav-contact')}</a>
			</li>
			<li class="relative group">
				<div
					class="inline-flex items-center gap-2 px-[15px] py-[15px] cursor-pointer"
					class:py-[25px]={isScrolled}
				>
					<!-- Language  -->
					{$page.params.locale}
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256">
						<path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/>
					</svg>
				</div>
			
				<ul class="absolute left-0 top-full mt-1 bg-white border rounded shadow-md z-50
				           opacity-0 invisible group-hover:opacity-100 group-hover:visible
				           transition-all duration-200">
					<li><a data-sveltekit-reload href={`/en${currentPath}`} class="block px-4 py-2 hover:bg-gray-100">English</a></li>
					<li><a data-sveltekit-reload href={`/id${currentPath}`} class="block px-4 py-2 hover:bg-gray-100">Indonesia</a></li>
				</ul>
			</li>

		</ul>
	</div>
	<div class="flex items-center">
		<!-- <details class="dropdown dropdown-end"
			class:block={isScrolled}
			class:hidden={!isScrolled}
		>
			<summary class="btn m-1 text-primary uppercase">
				Eng
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"></path></svg>
			</summary>
			<ul class="menu dropdown-content bg-base-100 rounded-box z-[1] w-52 p-2 shadow uppercase">
				<li><a href="/">Eng</a></li>
				<li><a href="/">Id</a></li>
				<li><a href="/">Cn</a></li>
			</ul>
		</details> -->
		<!-- <div class="dropdown dropdown-end">
			<div tabindex="0" role="button" class="btn m-1 uppercase">
				Eng
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"></path></svg>
			</div>
			<ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow uppercase">
			  <li><a href="/">Eng</a></li>
			  <li><a href="/">Id</a></li>
			  <li><a href="/">Cn</a></li>
			</ul>
		</div> -->
		<a data-sveltekit-reload href="/{$page.params.locale}/contact"
			id="btn-booknow-2"
			class=" bg-secondary h-full px-[25px] uppercase font-primary items-center justify-center !transition-all !duration-300 hover:bg-primary hover:text-white"
			class:flex={isScrolled}
			class:hidden={!isScrolled}
			class:animate-slideIn={isScrolled}
			>
			{$_('nav-booknow')}
		</a>
	</div>
</div>

<!-- Header Mobile  -->
<div class="fixed top-0 w-full block sm:hidden py-[10px] px-5 bg-white z-50 shadow-[0_3px_10px_rgb(0,0,0,0.2)]">
	<div class="flex justify-between items-center">
		<img src="/images/jcc-logo-fit.png" class="h-[7vh] object-contain" alt="images">
		
		<div class="flex items-center">
			<!-- svelte-ignore a11y_consider_explicit_label -->
			<!-- <a href="/">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>
			</a> -->
			<div class="relative group">
				<div
					class="inline-flex items-center gap-2 px-[15px] py-[15px] uppercase"
					class:py-[25px]={isScrolled}
				>
					<!-- Language  -->
					{$page.params.locale}
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256">
						<path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/>
					</svg>
				</div>
			
				<ul class="absolute left-0 top-full mt-1 bg-white border rounded shadow-md z-50
						opacity-0 invisible group-hover:opacity-100 group-hover:visible
						transition-all duration-200">
					<li><a data-sveltekit-reload href={`/en${currentPath}`} class="block px-4 py-2 hover:bg-gray-100">English</a></li>
					<li><a data-sveltekit-reload href={`/id${currentPath}`} class="block px-4 py-2 hover:bg-gray-100">Indonesia</a></li>
				</ul>
			</div>
			<div class="drawer drawer-end">
				<input id="my-drawer-4" type="checkbox" class="drawer-toggle" />
				<div class="drawer-content">
				  <!-- Page content here -->
				  <label for="my-drawer-4" class="">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>
				  </label>
				</div>
				<div class="drawer-side">
				  <label for="my-drawer-4" aria-label="close sidebar" class="drawer-overlay"></label>
				  
				  <div class="menu bg-[#F6F4ED] min-h-full w-full">
					<div class="flex justify-between items-center py-[10px] px-5 mb-[50px]">
						<img src="/images/jcc-logo-fit.png" class="h-[7vh] object-contain" alt="images">
						<label for="my-drawer-4" class="">
							<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
						</label>
					</div>
					<ul class="font-primary uppercase px-5 h-[50dvh] overflow-scroll">
						<li><a data-sveltekit-reload href="/{$page.params.locale}" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Home</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/about" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">About Us</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/venues" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Venues</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/events" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Events</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/offers" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Offers</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/services" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Services</a></li>
						<li><a data-sveltekit-reload href="/{$page.params.locale}/contact" class="py-[15px] px-0 border-b border-primary rounded-none text-[1.7dvh]">Contact Us</a></li>
					</ul>

					

					<div class="text-primary font-secondary w-full h-[25vh] fixed bottom-0 left-0 right-0 px-5 pb-5 flex flex-col justify-end bg-[#F6F4ED]">
						<p class="text-[1.1rem] mb-[10px]">{$_('footer-address')}</p>
						<ul class="text-[.9rem]">
							<li>
								<a href="{info[0].socials.gmap}" target="_blank" class="p-0">{info[0].address}</a>
							</li>
							<li>
								<a href="tel:{info[0].phone.number}" class="p-0">{info[0].phone.display}</a>
							</li>
							<li>
								<a href="mailto:{info[0].email}" target="_blank" class="p-0">{info[0].email}</a>
							</li>
						</ul>
						<div class="flex items-end justify-between">
							<ul class="flex gap-3 items-center mt-[20px] w-2/4">
								<li>
									<!-- svelte-ignore a11y_consider_explicit_label -->
									<a href="{info[0].socials.linkedin}" target="_blank" class="fill-primary p-0">
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z"></path></svg>
									</a>
								</li>
								<li>
									<!-- svelte-ignore a11y_consider_explicit_label -->
									<a href="{info[0].socials.facebook}" target="_blank" class="fill-primary p-0">
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm8,191.63V152h24a8,8,0,0,0,0-16H136V112a16,16,0,0,1,16-16h16a8,8,0,0,0,0-16H152a32,32,0,0,0-32,32v24H96a8,8,0,0,0,0,16h24v63.63a88,88,0,1,1,16,0Z"></path></svg>
									</a>
								</li>
								<li>
									<!-- svelte-ignore a11y_consider_explicit_label -->
									<a href="{info[0].socials.instagram}" target="_blank" class="fill-primary p-0">
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"></path></svg>
								</li>
								<li>
									<!-- svelte-ignore a11y_consider_explicit_label -->
									<a href="{info[0].socials.youtube}" target="_blank" class="fill-primary p-0">
										<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M164.44,121.34l-48-32A8,8,0,0,0,104,96v64a8,8,0,0,0,12.44,6.66l48-32a8,8,0,0,0,0-13.32ZM120,145.05V111l25.58,17ZM234.33,69.52a24,24,0,0,0-14.49-16.4C185.56,39.88,131,40,128,40s-57.56-.12-91.84,13.12a24,24,0,0,0-14.49,16.4C19.08,79.5,16,97.74,16,128s3.08,48.5,5.67,58.48a24,24,0,0,0,14.49,16.41C69,215.56,120.4,216,127.34,216h1.32c6.94,0,58.37-.44,91.18-13.11a24,24,0,0,0,14.49-16.41c2.59-10,5.67-28.22,5.67-58.48S236.92,79.5,234.33,69.52Zm-15.49,113a8,8,0,0,1-4.77,5.49c-31.65,12.22-85.48,12-86,12H128c-.54,0-54.33.2-86-12a8,8,0,0,1-4.77-5.49C34.8,173.39,32,156.57,32,128s2.8-45.39,5.16-54.47A8,8,0,0,1,41.93,68c30.52-11.79,81.66-12,85.85-12h.27c.54,0,54.38-.18,86,12a8,8,0,0,1,4.77,5.49C221.2,82.61,224,99.43,224,128S221.2,173.39,218.84,182.47Z"></path></svg>
									</a>
								</li>
							</ul>
							<!-- <div class=" font-primary px-5 mt-5">
								<p class="pb-2">Select Language</p>
								<ul class="flex gap-5">
									<li>
										<a href="/" class="border border-primary !p-0 rounded-none"><img src="/images/lang/indonesia.svg" alt="images"></a>
									</li>
									<li>
										<a href="/" class="border border-primary !p-0 rounded-none"><img src="/images/lang/english.svg" alt="images"></a>
									</li>
									<li>
										<a href="/" class="border border-primary !p-0 rounded-none"><img src="/images/lang/china.svg" alt="images"></a>
									</li>
								</ul>
							</div> -->
						</div>
					</div>
				  </div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Navigation Mobile  -->
<div class="fixed bottom-0 left-0 right-0 z-30 block sm:hidden">
	<!-- <a href="/" class="block w-[90%] mx-auto mb-3 text-center font-primary uppercase py-[18px] bg-secondary text-white shadow-[0_3px_10px_rgb(0,0,0,0.2)]">Book Availability</a> -->
	<ul class="bg-white font-primary uppercase flex justify-between  text-[.8rem] shadow-[0_3px_10px_rgb(0,0,0,0.2)]">
		<li class="w-[60%] text-primary text-[.6rem] flex justify-between p-2 px-[20px]">
			<a data-sveltekit-reload href="/" class="flex flex-col items-center py-2">
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256"><path d="M216.49,111.51l-80-80a12,12,0,0,0-17,0l-80,80A12,12,0,0,0,36,120v96a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V156h40v60a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V120A12,12,0,0,0,216.49,111.51ZM212,212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44V120a4,4,0,0,1,1.17-2.83l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,212,120Z"></path></svg>
				<p class="text-primary">{$_('nav-home')}</p>
			</a>
			<a data-sveltekit-reload href="/venues" class="flex flex-col items-center py-2">
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256"><path d="M24,100H52v72H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8H204V100h28a4,4,0,0,0,2.1-7.41l-104-64a4,4,0,0,0-4.2,0l-104,64A4,4,0,0,0,24,100Zm36,0h40v72H60Zm88,0v72H108V100Zm48,72H156V100h40ZM128,36.7,217.87,92H38.13ZM244,208a4,4,0,0,1-4,4H16a4,4,0,0,1,0-8H240A4,4,0,0,1,244,208Z"></path></svg>
				<p class="text-primary">{$_('nav-venues')}</p>
			</a>
			<a data-sveltekit-reload href="/offers" class="flex flex-col items-center py-2">
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256"><path d="M216,76H166.81a50.54,50.54,0,0,0,12.63-8A25.53,25.53,0,0,0,188,49.44,28.62,28.62,0,0,0,158.56,20,25.53,25.53,0,0,0,140,28.56c-5.91,6.67-9.63,15.36-12,23.69-2.35-8.33-6.07-17-12-23.69A25.53,25.53,0,0,0,97.44,20,28.62,28.62,0,0,0,68,49.44,25.53,25.53,0,0,0,76.56,68a50.54,50.54,0,0,0,12.63,8H40A12,12,0,0,0,28,88v32a12,12,0,0,0,12,12h4v68a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V132h4a12,12,0,0,0,12-12V88A12,12,0,0,0,216,76ZM146,33.86A17.59,17.59,0,0,1,158.8,28h.61A20.62,20.62,0,0,1,180,49.2,17.6,17.6,0,0,1,174.14,62c-12.09,10.7-33.07,13.21-42,13.79C132.76,66.93,135.26,46,146,33.86ZM76,49.2A20.62,20.62,0,0,1,96.59,28h.61A17.59,17.59,0,0,1,110,33.86c10.71,12.09,13.21,33.07,13.79,42-8.89-.58-29.87-3.09-42-13.79A17.6,17.6,0,0,1,76,49.2ZM36,120V88a4,4,0,0,1,4-4h84v40H40A4,4,0,0,1,36,120Zm16,80V132h72v72H56A4,4,0,0,1,52,200Zm152,0a4,4,0,0,1-4,4H132V132h72Zm16-80a4,4,0,0,1-4,4H132V84h84a4,4,0,0,1,4,4Z"></path></svg>
				<p class="text-primary">{$_('nav-offers')}</p>
			</a>
		</li>
		<!-- <li class="w-[15%]">
			
		</li>
		<li class="w-[15%]">
			
		</li> -->
		<li class="w-[40%] flex items-center justify-center">
			<a href="mailto:apdpshamice@ihg.com" target="_blank" class="text-primary font-primary uppercase w-full h-full text-center tracking-[2px] bg-secondary flex justify-center items-center text-[1.1rem]">{$_('venue-book')}</a>
		</li>
		<!-- <li class="w-[20%]">
			<a data-sveltekit-reload href="/events" class="flex flex-col items-center pt-[20px]">
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-68-76a12,12,0,1,1-12-12A12,12,0,0,1,140,132Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,132ZM96,172a12,12,0,1,1-12-12A12,12,0,0,1,96,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,172Z"></path></svg>
				<p class="text-primary">Events</p>
			</a>
		</li> -->
		
		<!-- <li class="w-[20%]">
			<a data-sveltekit-reload href="/about" class="flex flex-col items-center pt-[20px]">
				<svg class="fill-primary" xmlns="http://www.w3.org/2000/svg" width="32" height="32"  viewBox="0 0 256 256"><path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>
				<p class="text-primary">About</p>
			</a>
		</li> -->
	</ul>
</div>